import useDashboardContext from 'contexts/dashboard.context';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTE_KEYS } from 'utils/constants';

const CreateCokitchen = () => {
  const navigate = useNavigate();
  const { routePrefix } = useDashboardContext();
  useEffect(() => {
    navigate(
      `${routePrefix}/${ROUTE_KEYS.CREATE_COKITCHEN}/${ROUTE_KEYS.CREATE_COKITCHEN_KITCHEN}`,
      {
        replace: true
      }
    );
  }, []);
  return <div />;
};

export default CreateCokitchen;
